import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface ProductCardPlaceholderProps {
  /** 폭별 노출 등 바깥 그리드가 정하는 클래스. */
  readonly className?: string;
}

/** 상품 카드 자리의 빈 칸 — 카드 사진 칸과 같은 비율(4:5)의 글자 없는 각진 회색 면이다. */
export const ProductCardPlaceholder = ({
  className,
}: ProductCardPlaceholderProps): ReactElement => (
  <div aria-hidden className={cn('aspect-[4/5] w-full bg-muted/70', className)} />
);
